import React from 'react';
import PropTypes from 'prop-types';
import { Field } from '../controls';

export const StoreUrlField = ({
    label,
    value,
    committedValue,
    placeholder = '',
    disabled = false,
    error = null,
    onCommit,
    onDraftChange,
    onBlur = () => {},
    className = '',
}) => {
    const commitValue = nextValue => {
        if (nextValue !== (committedValue || '')) {
            onCommit(nextValue);
        }
    };

    return (
        <Field
            className={className}
            disabled={disabled}
            error={error}
            label={label}
            placeholder={placeholder}
            value={value}
            onBlur={() => {
                commitValue(value || '');
                onBlur();
            }}
            onChange={nextValue => {
                onDraftChange(nextValue);
            }}
        />
    );
};

StoreUrlField.propTypes = {
    className: PropTypes.string,
    committedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
    error: PropTypes.string,
    label: PropTypes.node.isRequired,
    onBlur: PropTypes.func,
    onCommit: PropTypes.func.isRequired,
    onDraftChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
